import React from 'react'
import { map } from 'lodash'
import classes from './TagItems.module.less'

export type TagItemType = {
    label: string
    value: string
    colorHex?: `#${string}`
    onClick?: () => void
}

export type TagItemsProps = {
    items: { [key: string]: TagItemType | undefined }
}

export const TagItems: React.FC<TagItemsProps> = (props: TagItemsProps) => {
    return (
        <div className={classes.container} data-testid="analysis-items-container">
            {map(props.items, (item, key) => {
                if (!item) return null
                return (
                    <button className={classes.item} key={key} onClick={item.onClick ?? (() => {})}>
                        <span>{item.label}:&nbsp;</span>
                        <strong
                            style={{
                                color: item.colorHex,
                            }}
                        >
                            {item.value}
                        </strong>
                    </button>
                )
            })}
        </div>
    )
}
